import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17488 18903"
    {...props}
  >
    <path
      d="m6695 1880 2318 1952 2923-3490c314-375 849-452 1180-180 332 281 349 815 36 1198l-2924 3492 2931 2447 2897-3458c306-374 841-459 1172-178s348 815 34 1189l-2888 3466 2327 1945c417 348 476 977 128 1393-349 425-977 477-1393 126L5420 3399c-416-349-475-975-119-1393 348-416 977-476 1394-126zM0 17927l4342-4368 984 978-4332 4366-994-976zM6091 6280 4077 8693c-534 637-364 1666 374 2286l3704 3100c730 620 1775 603 2302-33l2021-2415-6387-5351zm-203-1121L3212 8352c-705 849-552 2158 340 2905l4486 3755c891 749 2199 671 2904-177l2676-3204-7730-6472zm-230-1045L2362 8063c-875 1045-739 2608 305 3483l5242 4384c1028 875 2599 739 3475-305l3305-3951-9031-7560z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
